import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const AddSampleTypeDialog = ({
  isOpen,
  onClose,
  sampleTypeName,
  onSampleTypeNameChange,
  onAddClick
}) => {
  const handleAdd = () => {
    onAddClick();
  };

  const handleClose = () => {
    onClose();
    onSampleTypeNameChange('');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Legg til ny prøvetype</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Prøvetype *</Label>
            <Input
              value={sampleTypeName}
              onChange={(e) => onSampleTypeNameChange(e.target.value)}
              placeholder="f.eks. Bunnprøve"
              className="mt-2"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleAdd();
                }
              }}
            />
          </div>
          <div className="flex space-x-2">
            <Button onClick={handleAdd} className="flex-1 bg-teal-600 hover:bg-teal-700">
              Legg til prøvetype
            </Button>
            <Button 
              variant="outline" 
              onClick={handleClose} 
              className="flex-1"
            >
              Avbryt
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AddSampleTypeDialog;
